import React from 'react';
import { useNavigate } from 'react-router-dom';
import NousLogo from './NousLogo';

export default function GlobalFooter() {
  const navigate = useNavigate();

  return (
    <>
    <style>{`
      .global-footer-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 3rem;
        margin-bottom: 4rem;
      }
      .global-footer-app-btn {
        background: rgba(255,255,255,0.05);
        border: 1px solid rgba(255,255,255,0.1);
        padding: 0.8rem 1.5rem;
        border-radius: 12px;
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        transition: background 0.2s;
        margin-bottom: 0.75rem;
      }
      .global-footer-app-btn:hover { background: rgba(255,255,255,0.1); }
      @media (max-width: 768px) {
        .global-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 2rem !important; }
      }
      @media (max-width: 480px) {
        .global-footer-grid { grid-template-columns: 1fr !important; gap: 2rem !important; }
        .global-footer-bottom { flex-direction: column !important; gap: 0.5rem !important; text-align: center; }
      }
    `}</style>
    <footer style={{ background: '#03050a', padding: '5rem 5% 3rem 5%', borderTop: '1px solid rgba(255,255,255,0.05)', color: 'rgba(255,255,255,0.6)' }}>
      <div className="global-footer-grid">
        
        {/* COLUMNA 1: Marca */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <NousLogo size="small" showSlogan={false} variant="metrics" />
          <p style={{ fontSize: '1.1rem', lineHeight: 1.6, fontWeight: 300, color: 'rgba(255,255,255,0.8)' }}>
            La disciplina genera datos.<br/>
            Nous crea el significado.
          </p>
        </div>

        {/* COLUMNA 2: Ecosistema */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <h4 style={{ color: 'white', fontWeight: 700, fontSize: '1.2rem', marginBottom: '0.5rem' }}>Ecosistema</h4>
          <button onClick={() => navigate('/soma')} style={{ background: 'none', border: 'none', color: 'inherit', textAlign: 'left', cursor: 'pointer', padding: 0, fontSize: '1rem', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = '#fc4c02'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>NousSoma (Atletas)</button>
          <button onClick={() => navigate('/mentor')} style={{ background: 'none', border: 'none', color: 'inherit', textAlign: 'left', cursor: 'pointer', padding: 0, fontSize: '1rem', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = '#8b5cf6'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>NousMentor (Coach)</button>
          <button onClick={() => navigate('/app')} style={{ background: 'none', border: 'none', color: 'inherit', textAlign: 'left', cursor: 'pointer', padding: 0, fontSize: '1rem', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = 'white'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Iniciar Sesión</button>
        </div>

        {/* COLUMNA 3: Compañía */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <h4 style={{ color: 'white', fontWeight: 700, fontSize: '1.2rem', marginBottom: '0.5rem' }}>NousMetrics</h4>
          <button onClick={() => navigate('/manifiesto')} style={{ background: 'none', border: 'none', color: 'inherit', textAlign: 'left', cursor: 'pointer', padding: 0, fontSize: '1rem', fontFamily: 'inherit', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = 'white'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Manifiesto</button>
          <a href="/presentacion" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = '#00e5ff'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Presentación & Dossier ↗</a>
          <a href="#" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = 'white'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Partners</a>
          <a href="/privacy.html" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = 'white'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Política de Privacidad</a>
          <a href="/terms.html" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={e => e.target.style.color = 'white'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Condiciones de Uso</a>
        </div>

        {/* COLUMNA 4: Apps */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <h4 style={{ color: 'white', fontWeight: 700, fontSize: '1.2rem', marginBottom: '0.5rem' }}>Descarga la App</h4>
          <p style={{ fontSize: '0.9rem', marginBottom: '0.5rem' }}>Lleva tu entrenador IA en el bolsillo.</p>
          <div className="global-footer-app-btn">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px' }}>
              <svg viewBox="0 0 384 512" fill="currentColor" style={{ width: '28px', height: '28px', color: '#fff' }}>
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
              </svg>
            </div>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Próximamente en</div>
              <div style={{ fontWeight: 700, color: 'white', fontSize: '1.1rem' }}>App Store</div>
            </div>
          </div>
          <div className="global-footer-app-btn">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px' }}>
              <svg viewBox="0 0 512 512" fill="currentColor" style={{ width: '28px', height: '28px', color: '#fff' }}>
                <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
              </svg>
            </div>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Próximamente en</div>
              <div style={{ fontWeight: 700, color: 'white', fontSize: '1.1rem' }}>Google Play</div>
            </div>
          </div>
        </div>
      </div>

      {/* AVISO MÉDICO Y PRIVACIDAD */}
      <div style={{ marginTop: '2.5rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.05)', fontSize: '0.75rem', color: 'rgba(255,255,255,0.4)', lineHeight: 1.6, textAlign: 'center', maxWidth: '900px', margin: '2.5rem auto 0' }}>
        <p style={{ margin: 0 }}>
          <strong>Aviso de Salud y Rendimiento:</strong> NousMetrics es una herramienta tecnológica para la monitorización del rendimiento deportivo y la optimización del entrenamiento mediante algoritmos de variabilidad cardíaca y carga de trabajo. No proporciona diagnósticos médicos, tratamientos ni sustituye la valoración de un profesional de la medicina deportiva. Consulta siempre a tu médico antes de iniciar programas de alta exigencia física.
        </p>
      </div>

      <div className="global-footer-bottom" style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '2rem', marginTop: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', fontSize: '0.85rem' }}>
        <p>© 2026 NousMetrics. Todos los derechos reservados.</p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap' }}>
          <p>Un producto de <strong style={{color: 'white'}}>Avantys Design S.L.</strong></p>
          <div style={{ display: 'flex', alignItems: 'center', opacity: 0.7 }}>
            {/* Powered by Strava - Light SVG for Dark Mode */}
            <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="120" height="30">
              <path d="M495.14 266.36L322.95 605.95h139.73l32.45-64.38 32.45 64.38h139.73L495.14 266.36zM701.37 605.95h-94.61l-47.93 94.62-47.93-94.62h-94.6l142.53 282.88 142.54-282.88z" />
              <text x="100" y="600" fontFamily="Arial, Helvetica, sans-serif" fontSize="240" fill="#ffffff" fontWeight="bold">POWERED BY STRAVA</text>
            </svg>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}
